var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNavbarItem(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 5.19961H1M1 8.39961H3.83734C4.26949 8.39961 4.48557 8.39961 4.69451 8.43685C4.87996 8.46991 5.06088 8.52469 5.23353 8.60005C5.42803 8.68496 5.60782 8.80482 5.96739 9.04454L6.43261 9.35468C6.79218 9.5944 6.97197 9.71425 7.16647 9.79916C7.33912 9.87453 7.52004 9.92931 7.70549 9.96237C7.91443 9.99961 8.13051 9.99961 8.56266 9.99961H9.43734C9.86949 9.99961 10.0856 9.99961 10.2945 9.96237C10.48 9.92931 10.6609 9.87453 10.8335 9.79916C11.028 9.71425 11.2078 9.5944 11.5674 9.35468L12.0326 9.04454C12.3922 8.80482 12.572 8.68496 12.7665 8.60005C12.9391 8.52469 13.12 8.46991 13.3055 8.43685C13.5144 8.39961 13.7305 8.39961 14.1627 8.39961H17M1 4.15961L1 11.8396C1 12.7357 1 13.1837 1.17439 13.526C1.32779 13.8271 1.57256 14.0718 1.87362 14.2252C2.21587 14.3996 2.66392 14.3996 3.56 14.3996L14.44 14.3996C15.3361 14.3996 15.7841 14.3996 16.1264 14.2252C16.4274 14.0718 16.6722 13.8271 16.8256 13.526C17 13.1837 17 12.7357 17 11.8396V4.15961C17 3.26353 17 2.81548 16.8256 2.47323C16.6722 2.17217 16.4274 1.9274 16.1264 1.774C15.7841 1.59961 15.3361 1.59961 14.44 1.59961L3.56 1.59961C2.66392 1.59961 2.21587 1.59961 1.87362 1.774C1.57256 1.9274 1.32779 2.17217 1.17439 2.47322C1 2.81548 1 3.26353 1 4.15961Z",
    stroke: "#CCCCCC",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavbarItem);
export default __webpack_public_path__ + "static/media/navbar-item.2207a3fd9bd55940a103e2135c9bc74a.svg";
export { ForwardRef as ReactComponent };